import { StandardModal } from "@design-system/Modal/Modal";
import { useContext, useState } from "react";
import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import { Menu } from "@design-system/Menu/Menu.lib";
import { UploadIcon } from "@icons";
import importerStyles from "@components/importer/ImporterPage.module.scss";
import { getAccrualDocumentImporterConfig } from "./accrualDocumentImporter.lib";
import { AccrualImporterContext } from "./accrualImporter.context";
import { AccrualImporterPickExistingDocument } from "./AccrualImporterPickExistingDocument";

interface Props {
    uploadNew: () => void;
}

export const AccrualImporterUploadPrompt: React.FC<Props> = ({ uploadNew }) => {
    const { mode } = useContext(AccrualImporterContext);
    const config = getAccrualDocumentImporterConfig(mode);
    const [isPickingExistingDocument, setIsPickingExistingDocument] =
        useState(false);

    return (
        <>
            <Menu.Root
                side="top"
                trigger={
                    <Button
                        className={importerStyles.uploadPrompt}
                        variant="primary"
                        size="md"
                        leftIcon={
                            <UploadIcon
                                className="icon-color-current"
                                width="12"
                                height="12"
                            />
                        }
                    >
                        {config.uploadDropzoneLabel}
                    </Button>
                }
            >
                <Menu.Item onClick={uploadNew}>
                    {config.uploadMenuItemLabel}
                </Menu.Item>
                <Menu.Item onClick={() => setIsPickingExistingDocument(true)}>
                    Browse from documents
                </Menu.Item>
            </Menu.Root>

            <StandardModal
                className={classNames(
                    importerStyles.documentSelectModal,
                    "fullscreen-modal",
                )}
                show={isPickingExistingDocument}
                onHide={() => setIsPickingExistingDocument(false)}
            >
                <AccrualImporterPickExistingDocument />
            </StandardModal>
        </>
    );
};
